// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3YxWX","text":"SelectPayment_text__3mMq5","title":"SelectPayment_title__3eA5-","btn":"SelectPayment_btn__3_DEa"};